export class Alert {
    id: number;
    type: AlertType;
    title: string;
    message: string;
    autoClose: boolean;
    fade: boolean;

    constructor(init?: Partial<Alert>) {
        this.id = 0;
        this.type = 1
        this.title = ''
        this.message = '';
        this.autoClose = true;
        this.fade = true;
        Object.assign(this, init);
    }
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}
